module.exports = __webpack_public_path__ + "static/img/aizhushou.21bebf05.png";